import { createAsyncThunk } from '@reduxjs/toolkit';
import { cardAPI } from '../utils/api/cardAPI';

export const fetchCards = createAsyncThunk('FETCH_CARDS', async () => cardAPI.fetchCards());
